import { PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { useFetch } from '../../../hooks/useFetch';
import { Collaborator } from '../../../domain/collaborator';
import { usePagination } from '../../../hooks/usePagination';
import { Role } from '../../../domain/Role';

export interface CollaboratorsQueryParams extends PageQueryParams {
  idMerchant?: string[];
  idBranch?: string[];
  userRole?: Role[];
}

const initalParams: CollaboratorsQueryParams = {
  page: 0,
  size: 5,
  idBranch: [],
  idMerchant: [],
  userRole: []
};

export const useCollaboratorParams = () => {
  const { queryParams, setParam, nextPage, prevPage, search } = usePagination<CollaboratorsQueryParams>(initalParams);
  const { data, error, loading } = useFetch<PageableResponseWrapper<Collaborator>>('/collaborators-view', queryParams);

  return {
    data,
    error,
    loading,
    queryParams,
    setParam,
    nextPage,
    prevPage,
    search
  };
};
